import {
  type PathLookupGraphPreset,
  type TopologyGraphPreset,
  isPathLookupGraphPreset,
  isTopologyGraphPreset,
  pathLookupGraphPresetSchema,
  safeAbsurd,
  topologyGraphPresetSchema,
} from '@ipfabric/utils';

export const isPresetValid = (
  preset: TopologyGraphPreset | PathLookupGraphPreset,
): boolean => {
  if (isTopologyGraphPreset(preset)) {
    return !topologyGraphPresetSchema.validate(preset).error;
  }
  if (isPathLookupGraphPreset(preset)) {
    return !pathLookupGraphPresetSchema.validate(preset).error;
  }
  safeAbsurd(preset);
  return false;
};
